(function () {
  const personalizationSelector = "[data-jersey-personalization]";

  let isReconcilingJerseyPersonalization = false;
  let isJerseyPersonalizationSyncPending = false;
  let jerseyPersonalizationReconcileTimeout = null;

  function getPageCartSettings() {
    const pageContainer = document.getElementById("PageContainer");
    const cartType = pageContainer?.dataset.cartType;
    const cartAction = pageContainer?.dataset.cartAction;
    const languageUrl = pageContainer?.dataset.languageUrl;
    const languageParam =
      !languageUrl || languageUrl === "/" ? "" : languageUrl;

    return {
      cartType,
      cartAction,
      languageParam,
    };
  }

  function getActivePersonalizationBlock(form, submitter) {
    const activeSubmitter = submitter || document.activeElement;
    const stickyAtc = activeSubmitter?.closest?.("sticky-add-to-cart");

    if (stickyAtc) {
      const stickyBlock = stickyAtc.querySelector(
        `${personalizationSelector}[data-jersey-personalization-sticky]`,
      );

      if (stickyBlock) {
        return stickyBlock;
      }

      const fallbackStickyBlock = stickyAtc.querySelector(
        personalizationSelector,
      );

      if (fallbackStickyBlock) {
        return fallbackStickyBlock;
      }
    }

    const productInformation = form.closest("product-information");

    if (productInformation) {
      const regularBlock = productInformation.querySelector(
        `${personalizationSelector}:not([data-jersey-personalization-sticky])`,
      );

      if (regularBlock) {
        return regularBlock;
      }
    }

    return document.querySelector(
      `${personalizationSelector}:not([data-jersey-personalization-sticky])`,
    );
  }

  function isPersonalizationSelected(personalizationBlock) {
    const toggle = personalizationBlock?.querySelector(
      "[data-jersey-personalization-toggle]",
    );

    return Boolean(toggle?.checked);
  }

  function getPersonalizationValues(personalizationBlock) {
    const nameInput =
      personalizationBlock.querySelector(
        "[data-jersey-personalization-name]",
      ) || personalizationBlock.querySelector('input[name="properties[Name]"]');

    const numberInput =
      personalizationBlock.querySelector(
        "[data-jersey-personalization-number]",
      ) ||
      personalizationBlock.querySelector('input[name="properties[Number]"]');

    return {
      nameInput,
      numberInput,
      name: nameInput?.value.trim() || "",
      number: numberInput?.value.trim() || "",
    };
  }

  function getFormLineItemProperties(formData) {
    const properties = {};

    formData.forEach((value, key) => {
      const propertyMatch = key.match(/^properties\[(.+)\]$/);

      if (!propertyMatch || value === "") return;

      const propertyName = propertyMatch[1];

      properties[propertyName] = value;
    });

    return properties;
  }

  function setPersonalizationInputsEnabled(personalizationBlock, enabled) {
    const formId = personalizationBlock.dataset.productFormId;
    const inputs = personalizationBlock.querySelectorAll(
      "[data-jersey-personalization-name], [data-jersey-personalization-number]",
    );

    inputs.forEach((input) => {
      if (enabled) {
        if (input.dataset.propertyName) {
          input.setAttribute("name", input.dataset.propertyName);
        }

        if (formId) {
          input.setAttribute("form", formId);
        }

        input.setAttribute("required", "required");
      } else {
        input.removeAttribute("name");
        input.removeAttribute("form");
        input.removeAttribute("required");
        input.classList.remove("is-invalid");
      }
    });
  }

  function updatePersonalizationState(personalizationBlock) {
    if (!personalizationBlock) return;

    const isSelected = isPersonalizationSelected(personalizationBlock);
    const content = personalizationBlock.querySelector(
      "[data-jersey-personalization-content]",
    );
    const errorElement = personalizationBlock.querySelector(
      "[data-jersey-personalization-error]",
    );
    const { name, number } = getPersonalizationValues(personalizationBlock);

    personalizationBlock.classList.toggle("is-selected", isSelected);
    personalizationBlock.classList.toggle(
      "is-complete",
      Boolean(isSelected && name && number),
    );

    if (content) {
      content.hidden = !isSelected;
    }

    setPersonalizationInputsEnabled(personalizationBlock, isSelected);

    if (!isSelected && errorElement) {
      errorElement.hidden = true;
    }
  }

  function validatePersonalizationBlock(personalizationBlock) {
    if (!personalizationBlock) return false;

    if (!isPersonalizationSelected(personalizationBlock)) {
      return true;
    }

    const { nameInput, numberInput, name, number } =
      getPersonalizationValues(personalizationBlock);
    const errorElement = personalizationBlock.querySelector(
      "[data-jersey-personalization-error]",
    );

    const isValid = Boolean(name && number);

    nameInput?.classList.toggle("is-invalid", !name);
    numberInput?.classList.toggle("is-invalid", !number);

    personalizationBlock.classList.toggle("is-complete", isValid);

    if (errorElement) {
      errorElement.hidden = isValid;
    }

    if (!isValid) {
      const firstInvalidInput = !name ? nameInput : numberInput;
      firstInvalidInput?.focus();
    }

    return isValid;
  }

  function validateThemeRequiredInputs(form) {
    const productForm = form.closest("product-form");

    if (!productForm || typeof productForm.checkRequiredInputs !== "function") {
      return true;
    }

    const isValid = productForm.checkRequiredInputs();

    const buttonWrapper = productForm.querySelector(".paymentButtonsWrapper");

    if (buttonWrapper) {
      let previousElement = buttonWrapper.previousElementSibling;

      while (
        previousElement &&
        previousElement.classList.contains("required-field-error")
      ) {
        const elementToRemove = previousElement;
        previousElement = previousElement.previousElementSibling;
        elementToRemove.remove();
      }
    }

    productForm
      .querySelectorAll('.required-field-error[id$="Submit"]')
      .forEach((error) => {
        error.remove();
      });

    return isValid;
  }

  function initJerseyPersonalizationFields(root = document) {
    const personalizationBlocks = root.querySelectorAll(
      personalizationSelector,
    );

    personalizationBlocks.forEach((personalizationBlock) => {
      if (
        personalizationBlock.dataset.jerseyPersonalizationInitialized === "true"
      ) {
        return;
      }

      personalizationBlock.dataset.jerseyPersonalizationInitialized = "true";
      updatePersonalizationState(personalizationBlock);
    });
  }
  function initJerseyPersonalizationFieldListeners() {
    if (window.__jerseyPersonalizationFieldListenersInitialized) return;

    window.__jerseyPersonalizationFieldListenersInitialized = true;

    document.addEventListener("change", function (event) {
      const toggle = event.target.closest(
        "[data-jersey-personalization-toggle]",
      );

      if (!toggle) return;

      const personalizationBlock = toggle.closest(personalizationSelector);

      updatePersonalizationState(personalizationBlock);
    });

    document.addEventListener("input", function (event) {
      const personalizationBlock = event.target.closest(
        personalizationSelector,
      );

      if (!personalizationBlock) return;

      const isPersonalizationInput =
        event.target.matches("[data-jersey-personalization-name]") ||
        event.target.matches("[data-jersey-personalization-number]");

      if (!isPersonalizationInput) return;

      const { nameInput, numberInput } =
        getPersonalizationValues(personalizationBlock);
      const errorElement = personalizationBlock.querySelector(
        "[data-jersey-personalization-error]",
      );

      updatePersonalizationState(personalizationBlock);

      nameInput?.classList.remove("is-invalid");
      numberInput?.classList.remove("is-invalid");

      if (errorElement) {
        errorElement.hidden = true;
      }
    });
  }

  function initJerseyPersonalizationMutationObserver() {
    if (window.__jerseyPersonalizationMutationObserverInitialized) return;

    window.__jerseyPersonalizationMutationObserverInitialized = true;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches?.(personalizationSelector)) {
            initJerseyPersonalizationFields(node.parentElement || document);
            return;
          }

          if (node.querySelector?.(personalizationSelector)) {
            initJerseyPersonalizationFields(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
  async function getCart() {
    const response = await fetch(window.routes?.cart_url || "/cart.js", {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Unable to fetch cart.");
    }

    return response.json();
  }

  async function changeCartItem(key, quantity, properties) {
    const { cartType } = getPageCartSettings();

    const payload = {
      id: key,
      quantity,
    };

    if (properties) {
      payload.properties = properties;
    }

    if (cartType === "drawer") {
      payload.sections = "cart-drawer";
    }

    const response = await fetch(
      window.routes?.cart_change_url || "/cart/change.js",
      {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      },
    );

    if (!response.ok) {
      throw new Error("Unable to change cart item.");
    }

    return response.json();
  }

  function isPersonalizedJersey(item) {
    return (
      item.properties &&
      item.properties._has_personalization === "true" &&
      item.properties._customization_id &&
      item.properties._personalization_removed !== "true"
    );
  }

  function isPersonalizationAddon(item) {
    return (
      item.properties &&
      item.properties._is_personalization_addon === "true" &&
      item.properties._customization_id
    );
  }

  function removePersonalizationProperties(properties) {
    const cleanedProperties = { ...(properties || {}) };

    delete cleanedProperties.Name;
    delete cleanedProperties.Number;
    delete cleanedProperties._customization_id;
    delete cleanedProperties._has_personalization;

    if (Object.keys(cleanedProperties).length === 0) {
      cleanedProperties._personalization_removed = "true";
    }

    return cleanedProperties;
  }

  function cartDrawerHasPersonalizedJersey() {
    return Boolean(
      document.querySelector(".cart-drawer__product_card--personalized-jersey"),
    );
  }

  function setPersonalizedJerseyControlsDisabled(disabled) {
    const jerseyCards = document.querySelectorAll(
      ".cart-drawer__product_card--personalized-jersey",
    );

    jerseyCards.forEach((card) => {
      const controls = card.querySelectorAll(
        "[data-cart-quantity-button], [data-cart-quantity-input], [data-cart-remove-item]",
      );

      controls.forEach((control) => {
        control.disabled = disabled;
        control.setAttribute("aria-disabled", disabled ? "true" : "false");
      });

      card.classList.toggle("is-personalization-syncing", disabled);
    });
  }

  async function refreshCartDrawer() {
    const { cartType, languageParam } = getPageCartSettings();

    if (cartType !== "drawer") return;

    const response = await fetch(`${languageParam}/cart?sections=cart-drawer`, {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) return;

    const sections = await response.json();

    if (window.eventBus) {
      window.eventBus.emit("update:cart:drawer", {
        sections,
      });
    }
  }

  function updateCartCount(cart) {
    if (
      window.wetheme &&
      typeof window.wetheme.updateCartCount === "function"
    ) {
      window.wetheme.updateCartCount(cart);
    }
  }

  async function reconcileJerseyPersonalizations(cartOverride) {
    const cart = cartOverride || (await getCart());

    if (!cart || !Array.isArray(cart.items)) {
      return {
        cartChanged: false,
        cart,
      };
    }

    const jerseys = cart.items.filter(isPersonalizedJersey);
    const addons = cart.items.filter(isPersonalizationAddon);

    const jerseyIds = jerseys.map((item) => item.properties._customization_id);
    const addonIds = addons.map((item) => item.properties._customization_id);

    let cartChanged = false;
    let latestCart = cart;

    for (const addon of addons) {
      const customizationId = addon.properties._customization_id;

      if (!jerseyIds.includes(customizationId)) {
        latestCart = await changeCartItem(addon.key, 0);
        cartChanged = true;
      }
    }

    for (const jersey of jerseys) {
      const customizationId = jersey.properties._customization_id;

      if (!addonIds.includes(customizationId)) {
        const cleanedProperties = removePersonalizationProperties(
          jersey.properties,
        );

        latestCart = await changeCartItem(
          jersey.key,
          jersey.quantity,
          cleanedProperties,
        );
        cartChanged = true;
      }
    }

    for (const jersey of jerseys) {
      const customizationId = jersey.properties._customization_id;

      const matchingAddon = addons.find((addon) => {
        return addon.properties?._customization_id === customizationId;
      });

      if (matchingAddon && matchingAddon.quantity !== jersey.quantity) {
        latestCart = await changeCartItem(matchingAddon.key, jersey.quantity);
        cartChanged = true;
      }
    }

    return {
      cartChanged,
      cart: latestCart,
    };
  }

  async function safeReconcileJerseyPersonalizations(cartOverride) {
    if (isReconcilingJerseyPersonalization) return;

    isReconcilingJerseyPersonalization = true;
    setPersonalizedJerseyControlsDisabled(true);

    try {
      const result = await reconcileJerseyPersonalizations(cartOverride);

      if (result.cartChanged) {
        updateCartCount(result.cart);

        if (result.cart?.sections && window.eventBus) {
          window.eventBus.emit("update:cart:drawer", result.cart);
        } else {
          await refreshCartDrawer();
        }
      }
    } catch (error) {
      console.error("Jersey personalization reconciliation failed:", error);
    } finally {
      isReconcilingJerseyPersonalization = false;
      isJerseyPersonalizationSyncPending = false;

      setTimeout(() => {
        setPersonalizedJerseyControlsDisabled(false);
      }, 300);
    }
  }

  function scheduleJerseyPersonalizationReconcile(cartOverride, delay = 250) {
    clearTimeout(jerseyPersonalizationReconcileTimeout);

    jerseyPersonalizationReconcileTimeout = setTimeout(() => {
      safeReconcileJerseyPersonalizations(cartOverride);
    }, delay);
  }

  function initCartDrawerUpdateGuard() {
    if (window.__jerseyPersonalizationDrawerGuardInitialized) return;
    if (!window.eventBus || typeof window.eventBus.emit !== "function") return;

    window.__jerseyPersonalizationDrawerGuardInitialized = true;

    const originalEmit = window.eventBus.emit.bind(window.eventBus);

    window.eventBus.emit = function (eventName, payload) {
      const shouldSuppressDrawerUpdate =
        eventName === "update:cart:drawer" &&
        isJerseyPersonalizationSyncPending &&
        !isReconcilingJerseyPersonalization;

      if (shouldSuppressDrawerUpdate) {
        return;
      }

      return originalEmit(eventName, payload);
    };
  }

  document.addEventListener(
    "submit",
    async function (event) {
      const form = event.target;

      if (!form.matches('form[action*="/cart/add"]')) return;

      const personalizationBlock = getActivePersonalizationBlock(
        form,
        event.submitter,
      );

      if (!personalizationBlock) return;

      const personalizationSelected =
        isPersonalizationSelected(personalizationBlock);

      if (!personalizationSelected) {
        return;
      }

      if (!validateThemeRequiredInputs(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (!validatePersonalizationBlock(personalizationBlock)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      const addonVariantId = personalizationBlock.dataset.addonVariantId;

      if (!addonVariantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const { cartType, cartAction, languageParam } = getPageCartSettings();

      const formData = new FormData(form);

      const productVariantId = formData.get("id");
      const quantity = Number(formData.get("quantity") || 1);
      const formProperties = getFormLineItemProperties(formData);

      const personalizationValues =
        getPersonalizationValues(personalizationBlock);

      const personalizationName = personalizationValues.name;
      const personalizationNumber = personalizationValues.number;

      const submitButtons = form.querySelectorAll(
        '[type="submit"], button[name="add"]',
      );

      submitButtons.forEach((button) => {
        button.classList.add("is-loading");
        button.setAttribute("aria-busy", "true");
      });

      const customizationId = `jersey-${productVariantId}-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2)}`;

      const items = [
        {
          id: Number(productVariantId),
          quantity,
          properties: {
            ...formProperties,
            Name: personalizationName,
            Number: personalizationNumber,
            _customization_id: customizationId,
            _has_personalization: "true",
          },
        },
        {
          id: Number(addonVariantId),
          quantity,
          properties: {
            _is_personalization_addon: "true",
            _customization_id: customizationId,
            Name: personalizationName,
            Number: personalizationNumber,
          },
        },
      ];

      try {
        const payload = {
          items,
        };

        if (cartType === "drawer") {
          payload.sections = "cart-drawer";
        }

        const response = await fetch(
          window.routes?.cart_add_url || "/cart/add.js",
          {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(payload),
          },
        );

        if (!response.ok) {
          throw new Error("Unable to add personalized jersey to cart.");
        }

        const responseJson = await response.json();

        if (cartType === "drawer" && window.eventBus) {
          window.eventBus.emit("update:cart:drawer", responseJson);
        }

        const cartResponse = await fetch(`${languageParam}/cart?view=compare`);

        if (!cartResponse.ok) {
          throw new Error("Unable to fetch updated cart.");
        }

        const cart = await cartResponse.json();

        if (
          cartType === "drawer" &&
          cartAction === "go_to_or_open_cart" &&
          window.eventBus
        ) {
          window.eventBus.emit("open:cart:drawer", {
            scrollToTop: true,
          });
        } else if (cartType === "page") {
          window.location.href = `${languageParam}/cart`;
          return;
        } else {
          submitButtons.forEach((button) => {
            button.classList.add("is-added");
          });
        }

        updateCartCount(cart);

        setTimeout(() => {
          submitButtons.forEach((button) => {
            button.classList.remove("is-loading");
            button.classList.remove("is-added");
            button.removeAttribute("aria-busy");
          });
        }, 2000);
      } catch (error) {
        console.error("Jersey personalization add to cart failed:", error);

        submitButtons.forEach((button) => {
          button.classList.remove("is-loading");
          button.classList.remove("is-added");
          button.removeAttribute("aria-busy");
        });
      }
    },
    true,
  );

  function cartNeedsJerseyPersonalizationReconcile(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;

    const jerseys = cart.items.filter(isPersonalizedJersey);
    const addons = cart.items.filter(isPersonalizationAddon);

    const jerseyIds = jerseys.map((item) => item.properties._customization_id);
    const addonIds = addons.map((item) => item.properties._customization_id);

    const hasOrphanAddon = addons.some((addon) => {
      return !jerseyIds.includes(addon.properties._customization_id);
    });

    const hasJerseyWithoutAddon = jerseys.some((jersey) => {
      return !addonIds.includes(jersey.properties._customization_id);
    });

    const hasQuantityMismatch = jerseys.some((jersey) => {
      const matchingAddon = addons.find((addon) => {
        return (
          addon.properties?._customization_id ===
          jersey.properties._customization_id
        );
      });

      return matchingAddon && matchingAddon.quantity !== jersey.quantity;
    });

    return hasOrphanAddon || hasJerseyWithoutAddon || hasQuantityMismatch;
  }

  function initCartFetchWatcher() {
    if (window.__jerseyPersonalizationFetchWatcherInitialized) return;

    window.__jerseyPersonalizationFetchWatcherInitialized = true;

    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);

      try {
        const request = args[0];
        const requestUrl =
          typeof request === "string" ? request : request?.url || "";

        const isCartChangeOrUpdate =
          requestUrl.includes("/cart/change") ||
          requestUrl.includes("/cart/update");

        if (isCartChangeOrUpdate && !isReconcilingJerseyPersonalization) {
          let cart = null;

          try {
            cart = await response.clone().json();
          } catch (error) {
            cart = null;
          }

          const shouldReconcile = cartNeedsJerseyPersonalizationReconcile(cart);

          if (shouldReconcile) {
            if (cartDrawerHasPersonalizedJersey()) {
              isJerseyPersonalizationSyncPending = true;
              setPersonalizedJerseyControlsDisabled(true);
            }

            scheduleJerseyPersonalizationReconcile(cart, 250);
          }
        }
      } catch (error) {
        console.error("Jersey personalization fetch watcher failed:", error);
      }

      return response;
    };
  }

  initJerseyPersonalizationFields();
  initJerseyPersonalizationFieldListeners();
  initJerseyPersonalizationMutationObserver();
  initCartDrawerUpdateGuard();
  initCartFetchWatcher();
})();
